import React from 'react'
import NaglowekSprStyle from '../styles/NaglowekSprStyle'
import { formatDate } from '../lib/formatDateHandler'
import NazwaStruktury from '../components/NazwaStruktury'

export default function NaglowekSprawozdania({
  OkresOd,
  OkresDo,
  KodSprawozdania,
}) {
  return (
    <NaglowekSprStyle>
      <main className={KodSprawozdania}>
        <h3>SPRAWOZDANIE FINANSOWE</h3>
        <NazwaStruktury KodSprawozdania={KodSprawozdania} />
        <p>
          ZA OKRES OD{' '}
          <span>{OkresOd ? formatDate(OkresOd) : '____-__-__'}</span> DO
          <span> {OkresDo ? formatDate(OkresDo) : '____-__-__'}</span>
        </p>
      </main>
    </NaglowekSprStyle>
  )
}
